import "./init";
import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "mobx-react";
import App from "./App";
import userStore from "./store/userStore";
import sessionStore from "./store/sessionStore";
import profileStore from "./store/profileStore";
import hatsStore from "./store/hatsStore";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { PostHogProvider } from "posthog-js/react";
import { queryClient } from "./queryClient";

import "./locales/i18n";
import { PostHogConfig } from "posthog-js";

const posthogOptions: Partial<PostHogConfig> = {
  api_host: "https://ph.hatsandladders.com/",
  ui_host: "https://us.posthog.com",
  defaults: "2025-05-24",
  autocapture: false,
  capture_exceptions: {
    capture_unhandled_errors: false,
    capture_unhandled_rejections: false,
    capture_console_errors: false,
  },
};

const stores = { userStore, sessionStore, profileStore, hatsStore };

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <PostHogProvider
      /* Post hog public API key is safe to share publicly */
      apiKey="phc_j6Nh0282Y2u8gJgddhb7KNyQ4FZ4GJ1ufCrI9VNZbyj"
      options={posthogOptions}
    >
      <QueryClientProvider client={queryClient}>
        <Provider {...stores}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
        {window.location.hostname === "localhost" && (
          <ReactQueryDevtools
            initialIsOpen={false}
            buttonPosition="bottom-left"
          />
        )}
      </QueryClientProvider>
    </PostHogProvider>
  </React.StrictMode>,
);
